module.exports = __webpack_public_path__ + "img/gradient-circle.ffabb2a0.svg";